<div class="bc-panel bc-layout-wrapper discussions-panel">
  <ng-container [ngSwitch]="discussionRequestState">

    <ng-container *ngSwitchCase="discussionStates.NOT_SET">
      <div class="bc-panel-header">
        <svg-icon icon="discussions" class="bc-panel-header-icon"></svg-icon>
        <span class="bc-panel-header-text">{{ 'discussions.choosePartner' | translate }}</span>
      </div>

      <div class="discussions-panel-body">
        <app-operators-list [workItemType]="workItemType"
                            [isAcdAvailable]="false"
                            [isDepartmentSelectable]="hasChatDiscussionAcd && isChat()"
                            (onOperatorSelected)="setSelectedOperator($event)"
                            class="discussions-operators-list">
        </app-operators-list>
        <app-alert-box [editorMessages]="errorMessages.messages" (closeHandler)="clearErrorMessage()"></app-alert-box>
      </div>

      <div class="discussions-footer" *ngIf="isFocused()">
        <app-editor [editorInitSetting]="editorInitSetting"
                    [(editorContentModel)]="editorContent.text"
                    (editorSetupDone)="onEditorSetupDone($event)"
                    [attr.data-automation-id]="'bc-discussions-not-set-editor'">
        </app-editor>

        <div class="footer-buttons">
          <button class="btn btn-dark send-button"
                  (click)="onSendRequestClick()"
                  [disabled]="!assignee || hasActiveDiscussion || initRequestInProgress"
                  [attr.data-automation-id]="'bc-discussions-not-set-send-request'">
            <span>{{ 'discussions.buttons.sendRequest' | translate }}</span>
          </button>

          <button class="btn btn-light close-button"
                  (click)="closeDiscussionPanel()"
                  [attr.data-automation-id]="'bc-discussions-not-set-close'">
            <span>{{ 'discussions.buttons.close' | translate }}</span>
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="discussionStates.WAITING">
      <div class="bc-panel-header">
        <svg-icon icon="discussions" class="bc-panel-header-icon"></svg-icon>
        <span class="bc-panel-header-text">{{ (helperName ? 'discussions.waitingFor' : 'discussions.waitingForAnAgentToAnswer') | translate: { helperName: helperName } }}</span>
      </div>

      <div class="discussions-panel-body editor-should-be-hidden" #scrollPane>
        <div class="discussions-messages-short">
          <app-discussions-messages [workItemId]="workItemId"
                                    [operatorType]="operatorType.OPERATOR"
          ></app-discussions-messages>
        </div>
        <div class="loading">
          <app-loading></app-loading>
        </div>
      </div>

      <div class="discussions-footer">
        <div class="footer-buttons">
          <button class="btn btn-light cancel-request-button"
                  (click)="onCancelDiscussionClick()"
                  [attr.data-automation-id]="'bc-discussions-waiting-cancel'">
            <span>{{ 'discussions.buttons.cancelDiscussionRequest' | translate }}</span>
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="discussionStates.ACCEPTED">
      <div class="bc-panel-header">
        <svg-icon icon="discussions" class="bc-panel-header-icon"></svg-icon>
        <span class="bc-panel-header-text">{{ 'discussions.discussionWith' | translate: { helperName: helperName } }}</span>
      </div>

      <div class="discussions-panel-body" #scrollPane>
        <app-discussions-messages [workItemId]="workItemId"
                                  [operatorType]="operatorType.OPERATOR">
        </app-discussions-messages>
      </div>

      <div class="discussions-footer" *ngIf="isFocused()">
        <app-editor [editorInitSetting]="editorInitSetting"
                    (editorSetupDone)="onEditorSetupDone($event)"
                    [(editorContentModel)]="editorContent.text"
                    [submitOnEnter]="true"
                    (onEditorSubmit)="onEditorSubmit($event)"
                    [attr.data-automation-id]="'bc-discussions-accepted-editor'">
        </app-editor>

        <div class="footer-buttons">
          <button *ngIf="!workItemIsEnded" class="btn btn-light transfer-button" (click)="onTransferClick()" [disabled]="isTransferButtonDisabled">
            <span>{{ 'discussions.buttons.transferTo' | translate: { helperName: helperName } }}</span>
          </button>

          <button class="btn btn-light end-button"
                  (click)="onEndDiscussionClick()"
                  [attr.data-automation-id]="'bc-discussions-accepted-end'">
            <span>{{ 'discussions.buttons.endDiscussion' | translate }}</span>
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="discussionStates.ENDED">
      <div class="bc-panel-header">
        <svg-icon icon="discussions" class="bc-panel-header-icon"></svg-icon>
        <span class="bc-panel-header-text">{{ 'discussions.discussion' | translate }}</span>
      </div>

      <div class="discussions-panel-body editor-should-be-hidden" #scrollPane>
        <app-discussions-messages [workItemId]="workItemId"
                                  [operatorType]="operatorType.OPERATOR">
        </app-discussions-messages>
      </div>

      <div class="discussions-footer">
        <div class="footer-buttons">
          <button class="btn btn-light discuss-button" (click)="onStartNewDiscussionClick()">
            <span>{{ 'discussions.buttons.startNewDiscussion' | translate }}</span>
          </button>

          <button class="btn btn-light close-button"
                  (click)="closeDiscussionPanel()"
                  [attr.data-automation-id]="'bc-discussions-ended-close'">
            <span>{{ 'discussions.buttons.close' | translate }}</span>
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="discussionStates.HELPING">
      <div class="bc-panel-header">
        <svg-icon icon="discussions" class="bc-panel-header-icon"></svg-icon>
        <span class="bc-panel-header-text">{{ 'discussions.discussion' | translate }}</span>
      </div>

      <div class="discussions-panel-body" #scrollPane>
        <app-discussions-messages [workItemId]="workItemId"
                                  [operatorType]="operatorType.HELPER">
        </app-discussions-messages>
      </div>

      <div class="discussions-footer" *ngIf="isFocused()">
        <app-editor [editorInitSetting]="editorInitSetting"
                    (editorSetupDone)="onEditorSetupDone($event)"
                    [(editorContentModel)]="editorContent.text"
                    [submitOnEnter]="true"
                    (onEditorSubmit)="onEditorSubmit($event)">
        </app-editor>

        <div class="footer-buttons">
          <button class="btn btn-light end-button"
                  (click)="onEndDiscussionClick()"
                  [attr.data-automation-id]="'bc-discussions-helping-end'">
            <span>{{ 'discussions.buttons.endDiscussion' | translate }}</span>
          </button>
        </div>
      </div>
    </ng-container>

  </ng-container>

  <app-auto-save *ngIf="workItemId" [model]="editorContent" [storageKey]="editorAutoSaveStorageKey"></app-auto-save>
</div>
